<template>
  <v-card>
    <v-card-text>
      <div class="d-flex justify-space-between w-100 align-center">
        <div class="subtitle1">{{ $t(`emailSettings.settingsTab.sensitivityLevel`) }}</div>
        <div class="ml-4 mb-1">
          <button-toggle-group
            v-model="localValue.scanSensitivity"
            :items="sensitivityLevels"
            :disabled="disabled"
            bg-color="indigo-pale"
            data-testid="sensitivity-level-toggle"
          />
        </div>
      </div>
      <div class="body2 mb-3 mt-2">
        {{ $t(`emailSettings.settingsTab.sensitivityLevelDescription`) }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType, toRefs } from "vue";
import { useI18n } from "vue-i18n";
import { ScanSensitivityLevels } from "@/constants/emails.ts";
import type { EmailSecuritySettings } from "@/_store/email-security/email-settings.module.ts";
import ButtonToggleGroup, { type ButtonToggleItem } from "@/components/ButtonToggleGroup.vue";
import { useTwoWayBinding } from "@/composables/useTwoWayBinding.ts";

export default defineComponent({
  name: "SensitivityLevelSelector",
  components: { ButtonToggleGroup },
  props: {
    modelValue: {
      type: Object as PropType<EmailSecuritySettings>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const { t } = useI18n();

    const { modelValue } = toRefs(props);
    const localValue = useTwoWayBinding(modelValue, (value) => {
      emit("update:modelValue", value);
    });

    const sensitivityLevels = computed<ButtonToggleItem[]>(() => [
      {
        value: ScanSensitivityLevels.LOW,
        label: t(`emailSettings.settingsTab.sensitivityLevels.${ScanSensitivityLevels.LOW}`),
      },
      {
        value: ScanSensitivityLevels.MEDIUM,
        label: t(`emailSettings.settingsTab.sensitivityLevels.${ScanSensitivityLevels.MEDIUM}`),
      },
      {
        value: ScanSensitivityLevels.HIGH,
        label: t(`emailSettings.settingsTab.sensitivityLevels.${ScanSensitivityLevels.HIGH}`),
      },
    ]);

    return {
      sensitivityLevels,
      localValue,
      ScanSensitivityLevels,
    };
  },
});
</script>

<style scoped lang="scss"></style>
